import { useCallback } from 'react'
import { useNavigate } from 'react-router-dom'

const useLogout = () => {
  const navigate = useNavigate()

  return useCallback(async () => {
    // 1. Clear localStorage (tokens, user data)
    localStorage.clear()

    // 2. Clear sessionStorage (if used)
    sessionStorage.clear()

    // 3. Clear React Router state (navigate to login & replace history)
    navigate('/', { replace: true })

    // 4. Clear Cache Storage (Service Workers, PWA caching)
    if ('caches' in window) {
      const cacheKeys = await caches.keys()
      await Promise.all(cacheKeys.map(key => caches.delete(key)))
    }

    // 5. Unregister Service Workers (if used)
    if ('serviceWorker' in navigator) {
      const registrations = await navigator.serviceWorker.getRegistrations()
      await Promise.all(registrations.map(reg => reg.unregister()))
    }

    // 6. Force a hard refresh (optional, ensures no cached data remains)
    window.location.reload(true) // `true` forces a full reload from the server
  }, [navigate])
}

export default useLogout
